import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";
import { getPrincipalMessage } from "../Service/Api";

const ManagementMessage = ({ category }) => {
  // 👈 receive prop
  const [messageData, setMessageData] = useState(null);

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        const response = await getPrincipalMessage();
        const person = response.find(
          (item) => item.category?.toLowerCase() === category?.toLowerCase(),
        );
        if (person) {
          setMessageData(person);
        }
      } catch (error) {
        console.error("Error fetching management message:", error);
      }
    };

    if (category) {
      // 👈 guard now checks prop, not query param
      fetchMessage();
    }
  }, [category]); // 👈 depend on prop

  const getDisplayName = (cat) => {
    if (!cat) return "";
    return cat.toLowerCase() === "president" ? "Patron" : cat;
  };

  const displayName = getDisplayName(category); // 👈 use prop
  const pageTitle = `${displayName} Message`;

  return (
    <>
      <Header />
      <Breadcrumb title={pageTitle} pageName={pageTitle} mid="Management" />
      <div className="innerSection management_message">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {messageData ? (
                <>
                  <h3 className="inner_title">{pageTitle}</h3>
                  <h5>{messageData.name}</h5>
                  <h6>({messageData.category})</h6>
                  {messageData.attachments &&
                    messageData.attachments.length > 0 && (
                      <LazyLoad>
                        <img
                          src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${messageData.attachments[0]}`}
                          className="img-fluid border_img float-image"
                          alt={messageData.name}
                        />
                      </LazyLoad>
                    )}
                  {messageData.message?.trim().length > 10 ? (
                    <div
                      className="message-content"
                      dangerouslySetInnerHTML={{ __html: messageData.message }}
                    />
                  ) : (
                    <div className="message-content">
                      <p>Coming soon...</p>
                    </div>
                  )}
                </>
              ) : (
                <p>Loading message...</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ManagementMessage;
